export const compiledStorageRuntimeEpoch = 11;

export const storageRuntimeEpochQueryParam = 'storageRuntimeEpoch';

export const parseStorageRuntimeEpoch = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isSafeInteger(value) && value > 0) {
    return value;
  }
  if (typeof value === 'string' && /^[1-9]\d*$/.test(value)) {
    return Number(value);
  }
  return undefined;
};

export const localStorageSharedWorkerName = (storageRuntimeEpoch: number) =>
  `alfrec-local-storage-v${storageRuntimeEpoch}`;

export const parseSharedWorkerEpoch = (name: string): number | undefined => {
  const match = /^alfrec-local-storage-v([1-9]\d*)$/.exec(name);
  return match ? Number(match[1]) : undefined;
};

export const tabStorageRuntimeEpoch = (): number => {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const parsed = parseStorageRuntimeEpoch(
      new URLSearchParams(window.location.search).get(
        storageRuntimeEpochQueryParam,
      ),
    );
    if (parsed !== undefined) {
      return parsed;
    }
  }
  return compiledStorageRuntimeEpoch;
};
